import {Component} from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy-app.component.html',
  styleUrl: './privacy-policy-app.component.css'
})
export class PrivacyPolicyAppComponent {

}
